import React from 'react';
import { observer } from 'mobx-react';
import debounce from 'lodash/debounce';
import uniqueId from 'lodash/uniqueId';
import classNames from 'classnames';
import loadable from '@loadable/component';
import { Input } from 'components/Input';
import { SearchInput } from 'components/SearchInput';
import { Button } from 'components/Button';
import { Select } from 'components/Select';
import { Icon } from 'components/Icon';

import pageStore from 'stores/ReperksWidget/PageStore';
import constants from 'Constants';
import * as api from 'Api';
import * as utils from 'Utils';
import * as widgetUtils from 'stores/ReperksWidget/Utils';
import './styles.scss';



@observer
class ReperksWidget extends React.Component {
  constructor(props) {
    super(props);
  }

  getLauncher = () => {
    const widgetConfig = pageStore.widgetConfig;
    const launcher = widgetConfig.launcher;

    if (!utils.isPreview()) {
      if (!launcher.display) return null;
    }

    const otherProps = {};
    otherProps['toggle'] = () => pageStore.switchPanel();

    if (launcher.isExtendedVariant) {
      const ExtendedLauncher = loadable(() => import('./Launcher/Extended'));
      return (
        <ExtendedLauncher
          {...this.props}
          {...otherProps}
        />
      )
    }

    if (launcher.isMinimalVariant) {
      const MinimalLauncher = loadable(() => import('./Launcher/Minimal'));
      return (
        <MinimalLauncher
          {...this.props}
          {...otherProps}
        />
      )
    }

    return null;
  };

  getContainer = () => {
    const Container = loadable(() => import('./Container'));
    return (
      <Container
        toggle={() => pageStore.switchLauncher()}
        {...this.props}
      />
    )
  };

  render() {
    return (
      <div
        ref={this.currentRef}
        className="ov-reperks-widget"
      >

        {pageStore.isLauncherView ? (
          this.getLauncher()
        ): null}

        {pageStore.isPanelView ? (
          <div className="ov-overlay"></div>
        ): null}

        {pageStore.isPanelView ? (
          this.getContainer()
        ): null}
      </div>
    )
  }
};


export default ReperksWidget;


